import { BeforeYouStartTemplate, ContentBody } from '@templates';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RoutesList } from '../routes/Routes';
import { useHighwaysStore } from '@highways/store/store';
import { useEffect } from 'react';
import { HighwaysType } from '@highways/store/storeSlices/highwaysDetails';
import { CallToActionCardProps } from '@molecules/';
import { v4 as uuidv4 } from 'uuid';

const ASSISTANT_URL = import.meta.env.VITE_ASSISTANT_URL;

export const BeforeYouStartPage = () => {
  const navigate = useNavigate();
  const {
    updateHighwaysType,
    highwaysType,
    resetHighwaysDetails,
    updateSessionId,
    updateCaseReferenceId,
  } = useHighwaysStore();
  const [searchParams] = useSearchParams();
  const paramsType = (searchParams.get('type') ||
    HighwaysType.Road) as HighwaysType;
  const contentTitle = `Report a ${paramsType || highwaysType} damage issue`;
  const sessionId = uuidv4();
  const initiateForm = () => {
    updateSessionId(sessionId);
    navigate(RoutesList.HIGHWAYS_DAMAGE);
  };

  const assistantParams = {
    road: 'road_damage',
    pavement: 'pavement_damage',
  };

  // If no highways type is selected then use road as default for assistant
  const reportItAssistantRoute = `${ASSISTANT_URL}?category=${assistantParams[highwaysType ?? 'road']}`;
  const assistantCTA: CallToActionCardProps = {
    linkText: 'Use the assistant',
    linkSubtext: 'Use the chat style assistant to report the issue',
    externalHref: reportItAssistantRoute,
  };

  const reportItCTA: CallToActionCardProps = {
    linkText: 'Use the form',
    linkSubtext: 'Answer some questions to report the issue',
    onClick: initiateForm,
  };
  const callToActionCards = [assistantCTA, reportItCTA];
  const itemsToProvideContent = {
    sectionTitle: 'You will need to provide:',
    itemList: [
      `details on the ${highwaysType} damage`,
      'the location of the issue',
    ],
  };
  const usefullToProvideContent = {
    sectionTitle: "It's useful to provide:",
    itemList: [`images of the ${highwaysType} damage`, 'your contact details'],
  };

  const linkObjectArrays = [
    {
      level: 1,
      title: 'Home',
      href: 'https://www.westminster.gov.uk/',
    },
    {
      level: 2,
      title: 'Report it',
      href: 'https://www.westminster.gov.uk/report-it',
    },
    {
      level: 3,
      title: `Report ${paramsType} damage`,
    },
  ];

  const bodyContent = [itemsToProvideContent, usefullToProvideContent];

  useEffect(() => {
    if (
      highwaysType === null ||
      (highwaysType !== null && paramsType !== null)
    ) {
      updateHighwaysType(paramsType);
      resetHighwaysDetails();
      updateCaseReferenceId('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BeforeYouStartTemplate
      contentTitle={contentTitle}
      contentSubtext={<ContentBody content={bodyContent} />}
      callToActionCards={callToActionCards}
      linkObjectArrays={linkObjectArrays}
    />
  );
};
